<template>
  <div :class="uploaderBtnShow?'':'fileBoxComponentBoxView'" class="fileBoxComponentBox width-100  m-t-24" >
    <!-- 图片文件 - Flex布局 -->
    <div class="image-files-container width-100">
      <div 
        class="fileItem m-b-8" 
        v-for="(item, index) in imageFiles" 
        :key="'img-' + index"
        @click="handleFileClick(item)"
      >
        <div v-if="getFileType(item.name)=='image'" :class="(index + 1) % 2 === 0?'':'m-r-6'"  class="fileContainer rela">
          <van-image 
            width="100%" 
            height="100%" 
            fit="cover"
            :src="item.fileURL || item.previewUrl"
          />

          <div  v-if="!disabled"  class="absolute pos-t-0 pos-r-0 filesColse"> 
            <van-icon name="cross"  size="16"  @click.stop="filesColse(item)"  color="#ffffff"/>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 其他文件 - 行布局 -->
    <div class="other-files-container width-100 font-30">
      <div 
        class="fileItem other-file-item width-100  " 
        v-for="(item, index) in otherFiles" 
        :key="'other-' + index"
        @click="handleFileClick(item)"
      >
      <div :class="disabled?'other-file-content other-file-content-bai':'other-file-content'">
        <div class="fileNameBox">{{getFileDisplayName( item.name) }}</div>
        <div>{{'.'+item.fileType }}</div>
      </div>
      <van-icon v-if="!disabled" name="clear" class="m-l-12" @click.stop="filesColse(item)" />
      </div>
    </div>
    
    <!-- 图片预览 -->
    <van-image-preview 
      v-model="showImagePreview" 
      :images="currentImageList" 
      :start-position="currentImageIndex"
      @change="onImageChange"
    />
    
    <!-- 移动端PDF预览容器 -->
    <div v-show="showPdfPreview" class="pdfPreviewContainer">
      <iframe 
        :src="currentPdfUrl" 
        frameborder="0" 
        @load="onPdfLoaded"
      ></iframe>
    </div>
    
    <!-- 移动端Office文档预览弹窗 -->
    <van-popup 
      v-model="showOfficePreview" 
      class="filePreviewStyle"
      position="bottom" 
      :style="{ height: '90%', width: '100%', bottom: '0'}" 
      round
      closeable
      @close="closeOfficePreview"
    >
      <div class="title font-28  cor-33 p-24 text-center">{{selectedFile?selectedFile.name:''}}</div>
      <div class="officePreviewContainer">
        <iframe 
          :src="currentOfficeUrl" 
          frameborder="0" 
        ></iframe>
      </div>
    </van-popup>
    
    <!-- 文件下载确认弹窗 -->
    <van-action-sheet 
      v-model="showDownloadSheet" 
      :actions="downloadActions" 
      @select="onDownloadSelect"
      cancel-text="取消"
    />
  </div>
</template>

<script>
import * as ww from "@wecom/jssdk";
import mixin from "@/mixin/flow";
export default {
  name: 'FileComponent',
  mixins: [mixin],
  props: {
    fileListArr: {
      type: Array,
      default: []
    },
      // 添加一个可选的删除回调函数
    onFileRemove: {
      type: Function,
      default: null
    },
     // 是否禁用上传/删除
    disabled: {
      type: Boolean,
      default: false
    },
       //是否显示上传附件按钮(类似查看页面时使用,不能对附件进行操作)
    uploaderBtnShow: {
      type: Boolean,
      default: true
    },
  },
  watch: {
    fileListArr(newValue) { 
      console.log('fileListArr', newValue);
    }
  },
  computed: {
    // 计算属性：分离图片和其他文件
    imageFiles() {
      return this.fileListArr.filter(item => this.getFileType(item.name) === 'image');
    },
    otherFiles() {
      return this.fileListArr.filter(item => this.getFileType(item.name) !== 'image');
    },
    
    downloadActions() {
      return [
        { name: '在浏览器中打开', value: 'open' },
        { name: '下载文件', value: 'download' }
      ];
    }
  },
  data() {
    return {
      showImagePreview: false,
      showPdfPreview: false,
      showOfficePreview: false,
      showDownloadSheet: false,
      currentImageList: [],
      currentImageIndex: 0,
      currentPdfUrl: '',
      currentOfficeUrl: '',
      currentFile: null,
      selectedFile: null
    }
  },
  methods: {
     // 获取文件显示名称（去掉后缀）
  getFileDisplayName(fileName) {
    if (!fileName) return '';
    
    // 找到最后一个点的位置
    const lastDotIndex = fileName.lastIndexOf('.');
    
    // 如果没有点，或者点在第一个位置（如 .gitignore），返回原名称
    if (lastDotIndex === -1 || lastDotIndex === 0) {
      return fileName;
    }
    
    // 截取掉后缀
    return fileName.substring(0, lastDotIndex);
  },
     filesColse(item) {
      console.log('filesColse', item);
      // 发送事件到父组件，让父组件处理删除逻辑
      this.$emit('removeFile', item);
    },    // 获取文件扩展名（处理带查询参数的URL）
    getFileExtension(url) {
      if (!url) return '';
      
      // 去掉查询参数部分（?后面的内容）
      const cleanUrl = url.split('?')[0];
      
      // 获取扩展名
      const lastDotIndex = cleanUrl.lastIndexOf('.');
      if (lastDotIndex === -1) return '';
      
      return cleanUrl.substring(lastDotIndex).toLowerCase();
    },
    
    // 判断是否为图片文件
    isImageFile(url) {
      if (!url) return false;
      const ext = this.getFileExtension(url);
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      return imageExtensions.includes(ext);
    },
    
    // 判断是否为PDF文件
    isPdfFile(url) {
      if (!url) return false;
      const ext = this.getFileExtension(url);
      return ext === '.pdf';
    },
    
    // 判断是否为Word文件
    isWordFile(url) {
      if (!url) return false;
      const ext = this.getFileExtension(url);
      const wordExtensions = ['.doc', '.docx'];
      return wordExtensions.includes(ext);
    },
    
    // 判断是否为Excel文件
    isExcelFile(url) {
      if (!url) return false;
      const ext = this.getFileExtension(url);
      const excelExtensions = ['.xls', '.xlsx', '.csv'];
      return excelExtensions.includes(ext);
    },
    
    // 处理文件点击事件
    handleFileClick(item) {
      this.selectedFile = item;
      const fileUrl = item.fileURL || item.fileUrl;
      
      if (this.isImageFile(fileUrl)) {
        // 图片文件 - 预览
        this.previewImage(fileUrl);
      } else{
        this.previewDoc(item)
      }
      // else if (this.isPdfFile(fileUrl)) {
      //   // PDF文件 - 移动端优化预览
      //   this.previewPdf(fileUrl);
      // } else if (this.isWordFile(fileUrl) || this.isExcelFile(fileUrl)) {
      //   // Office文档 - 移动端优化预览
      //   this.previewOfficeDoc(fileUrl);
      // } else {
      //   // 其他文件 - 弹出操作选项
      //   this.currentFile = item;
      //   this.showDownloadSheet = true;
      // }
    },
    
    previewImage(file, a) {
      ImagePreview({
        images: this.imageFileList.map(item => item.previewUrl),
        startPosition: a.index,
      });
    },
    previewDoc(item) {
      if (this.$store.state.user.environmentType === 1) {
        this.registerWw().then(() => {
          console.log('registerWw completed, calling filePreview');
          ww.previewFile({
            url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
            name: item.name, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
            size: item.fileSize,// 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
          });
        }).catch((error) => {
          console.error('registerWw failed:', error);
          // 即使注册失败也尝试预览文件
          ww.previewFile({
            url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
            name: item.name, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
            size: item.fileSize,// 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
          });
        });
      } else {
        this.wwRegister(window.encodeURIComponent(location.href.split('#')[0]), ww => {
          ww.previewFile({
            url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
            name: item?.name,
            size: item.fileSize,
            success: function (res) {
              console.log('成功打开附件API', res)
            },
            fail: function (res) {
              console.log('打开附件API失败', res)
              // 在这里处理失败的情况，例如提示用户或进行其他操作
            }
          })
        })
      }
    },
    // 预览图片
    previewImage(imgUrl) {
      // 获取当前任务的所有图片URL
      this.currentImageList = this.getAllImageUrls();
      this.currentImageIndex = this.currentImageList.indexOf(imgUrl);
      this.showImagePreview = true;
    },
    
    // 获取当前任务中的所有图片
    getAllImageUrls() {
      if (!this.fileListArr) return [];
      return this.fileListArr
        .filter(file => this.isImageFile(file.fileURL || file.fileUrl))
        .map(file => file.fileURL || file.fileUrl);
    },
    
    // 判断文件类型
    getFileType(fileName) {
      if (!fileName) return 'other';
      
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const lowerFileName = fileName.toLowerCase();
      
      for (let ext of imageExtensions) {
        if (lowerFileName.endsWith(ext)) {
          return 'image';
        }
      }
      
      // 可以根据需要扩展更多类型
      if (lowerFileName.endsWith('.pdf')) return 'pdf';
      if (lowerFileName.endsWith('.doc') || lowerFileName.endsWith('.docx')) return 'word';
      if (lowerFileName.endsWith('.txt')) return 'text';
      
      return 'other';
    },
    
    // 预览PDF文件
    previewPdf(pdfUrl) {
      // 对URL进行特殊处理，编码文件名中的特殊字符
      const processedUrl = this.processUrlForSpecialChars(pdfUrl);
      console.log('processedUrl', processedUrl);
      this.currentPdfUrl = processedUrl;
      this.showPdfPreview = true;
    },
    
    // 处理URL中的特殊字符
    processUrlForSpecialChars(url) {
      if (!url) return url;
      
      try {
        // 分解URL为路径和查询参数两部分
        const urlParts = url.split('?');
        const pathPart = urlParts[0];
        const queryPart = urlParts.slice(1).join('?');
        
        // 获取路径的各部分
        const pathSegments = pathPart.split('/');
        const filenameSegment = pathSegments[pathSegments.length - 1];
        
        // 只对文件名部分进行特殊字符编码
        const encodedFilename = this.encodeFilename(filenameSegment);
        
        // 重新构建路径
        pathSegments[pathSegments.length - 1] = encodedFilename;
        const encodedPath = pathSegments.join('/');
        
        // 重新组装完整URL
        let finalUrl = encodedPath;
        if (queryPart) {
          finalUrl += '?' + queryPart;
        }
        
        return finalUrl;
      } catch (error) {
        console.error('Error processing URL for special chars:', error);
        return url; // 出错时返回原始URL
      }
    },

    // 编码文件名中的特殊字符
    encodeFilename(filename) {
      if (!filename) return filename;
      
      // 手动替换常见特殊字符
      return filename
        .replace(/\(/g, '%28')  // 左括号
        .replace(/\)/g, '%29')  // 右括号
        .replace(/\[/g, '%5B')  // 左方括号
        .replace(/\]/g, '%5D')  // 右方括号
        .replace(/\+/g, '%2B')  // 加号
        .replace(/#/g, '%23')   // 井号
        .replace(/ /g, '%20');  // 空格
    },
    
    // 预览Office文档
    previewOfficeDoc(docUrl) {
      // 使用微软Office在线预览服务
      const encodedUrl = encodeURIComponent(docUrl);
      this.currentOfficeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
      this.showOfficePreview = true;
    },
    
    // 关闭PDF预览
    closePdfPreview() {
      this.showPdfPreview = false;
      this.currentPdfUrl = '';
    },
    
    // 关闭Office预览
    closeOfficePreview() {
      this.showOfficePreview = false;
      this.currentOfficeUrl = '';
    },
    
    // 图片预览变化回调
    onImageChange(index) {
      this.currentImageIndex = index;
    },
    
    // PDF加载完成回调
    onPdfLoaded() {
      console.log('PDF loaded successfully');
    },
    
    // 下载操作选择
    onDownloadSelect(action) {
      if (action.value === 'download') {
        this.downloadFile(this.currentFile.fileURL || this.currentFile.fileUrl, this.currentFile.fileName);
      } else if (action.value === 'open') {
        window.open(this.currentFile.fileURL || this.currentFile.fileUrl, '_blank');
      }
      this.showDownloadSheet = false;
    },
    
    // 下载文件
    downloadFile(url, fileName) {
      if (!url) return;
      
      // 创建下载链接
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || '下载文件';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style lang="less">
.fileBoxComponentBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  .image-files-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    .fileItem{
      width: 50%;
    }
  }
  
  .other-files-container {
    margin-top: 8px;
  
  }
  
  .other-file-item {
    display: block;
    width: 100%;
    padding-top: 18px;
    // margin-bottom: 8px;
    // border: 1px solid #e5e5e5;
    border-radius: 4px;
    // background-color: #fafafa;
    cursor: pointer;
    
    &:hover {
      // background-color: #f0f0f0;
    }
  }
  
  .other-file-content {
    width:calc(100% - 40px);
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    line-height: 30px;
    color: #167CDB;
    display: flex;
    align-items: center;
    .fileNameBox{
      // max-width:calc(100% - 40px);
      width:calc(100% - 40px);
      white-space: nowrap; /* 防止文本换行 */
      overflow: hidden; /* 隐藏溢出的内容 */
      text-overflow: ellipsis; /* 溢出内容显示为省略号 */
      text-align: right;
    }
  }
  .other-file-content-bai{
     width:100%;
  }
  .cor167CDB{
    color: #167CDB;
  }
  
  .fileItem{
    cursor: pointer;
    transition: transform 0.2s;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    &:active {
      transform: scale(0.95);
    }
    .filesColse{
      width: 40px;
      height: 38px;
      background: rgba(0, 0, 0, 0.7);
      border-bottom-left-radius: 35px;
      line-height: 38px;
      padding-right: 2px;
    }
  }
  
  .fileContainer {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #eee;
    width:100%;
    height: 200px;
  }
  
  .filePlaceholder {
    border: 1px solid #ddd;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    background-color: #f8f9fa;
    
    &:active {
      background-color: #e9ecef;
    }
  }
  
  .pdfPreviewContainer,
  .officePreviewContainer {
    width: 100%;
    height: calc(100% - 100px);
    padding: 16px;
    box-sizing: border-box;
    overflow-y: auto;
    
    iframe {
      border-radius: 8px;
      background: white;
      width: 100%;
      height: calc(100% - 10px);
    }
  }
  
  .filePreviewStyle{
    .title{
      border: 2px solid #e5e5e5;
      font-weight: bold;
    }
    
    .van-popup__close-icon--top-right{
      top: 30px;
      right: 24px;
    }
    
    .van-icon{
      font-size: 32px;
      color: #333;
    }
  }
}
.fileBoxComponentBoxView{
   .image-files-container {
   
    justify-content:flex-start;
 
  }
  .other-file-content {
    .fileNameBox{
      width: auto;
      max-width:calc(100% - 40px);
    }
  }
}
</style>